import { ErrorFallback } from '@/components/shared/placeholders/Error';
import { Loading } from '@/components/shared/placeholders/Loading';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import React from 'react';

interface DashboardWidgetWrapperProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className: string;
  cardClassName?: string;
  isLoading?: boolean;
  isError?: boolean;
  refetch?: () => void;
}
export const DashboardWidgetWrapper: React.FC<DashboardWidgetWrapperProps> = ({
  title,
  description,
  children,
  className,
  cardClassName,
  isLoading,
  isError,
  refetch,
}) => {
  const showWidgetContent = !isLoading && !isError;
  return (
    <div className={cn('col-span-12', className)}>
      <Card className={cn('h-[300px] flex flex-col', cardClassName)}>
        <CardHeader>
          <CardTitle className="shrink-0">{title}</CardTitle>
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </CardHeader>

        <CardContent className="flex-1 min-h-0 flex flex-col">
          {isLoading && <Loading className="min-h-0 h-full" />}
          {isError && <ErrorFallback retry={refetch} />}
          {showWidgetContent && children}
        </CardContent>
      </Card>
    </div>
  );
};
